
const money = (v) => (v == null ? "—" : `${v < 0 ? "−" : v > 0 ? "+" : ""}$${Math.abs(v).toFixed(2)}`);
const tone = (v) => (v > 0 ? "text-emerald-300" : v < 0 ? "text-rose-300" : "text-slate-300");
const roi = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${v}%`);
const CATS = [["top pick", "Top Pick"], ["danger", "Danger"], ["roughie", "Roughie"]];

const Stat = ({ label, value, cls, testid }) => (
  <div data-testid={testid}><p className="text-[10px] uppercase tracking-widest text-slate-500">{label}</p><p className={`font-mono font-bold ${cls || "text-slate-50"}`}>{value}</p></div>
);

const Summary = ({ s, title, testid, big }) => (
  <div className={`rounded-xl bg-[#1B2640]/60 border border-[#202E4C] p-3 ${big ? "col-span-2" : ""}`} data-testid={testid}>
    <p className="text-[11px] uppercase tracking-widest text-slate-400 mb-2">{title}</p>
    <div className={`grid gap-2 ${big ? "grid-cols-3 sm:grid-cols-6" : "grid-cols-2 sm:grid-cols-3"}`}>
      <Stat label="Settled" value={s.settled} testid={`${testid}-settled`} />
      <Stat label="Won / lost" value={`${s.priced_wins} / ${s.priced_losses}`} testid={`${testid}-wl`} />
      <Stat label="Staked" value={`$${s.staked.toFixed(2)}`} testid={`${testid}-staked`} />
      <Stat label="Returned" value={`$${s.returned.toFixed(2)}`} testid={`${testid}-returned`} />
      <Stat label="Profit / loss" value={money(s.profit)} cls={tone(s.profit)} testid={`${testid}-profit`} />
      <Stat label="ROI" value={roi(s.roi_pct)} cls={tone(s.roi_pct)} testid={`${testid}-roi`} />
    </div>
    {(s.unpriced > 0 || s.pending > 0) && <p className="text-[11px] text-slate-500 mt-2">{[s.unpriced && `${s.unpriced} with no recorded price (can't be settled)`, s.pending && `${s.pending} awaiting results`].filter(Boolean).join(" · ")}</p>}
  </div>
);

export const TipPerformance = ({ t }) => {
  if (!t) return null;
  return (
    <section className="surface overflow-hidden mb-8" data-testid="tip-performance">
      <header className="px-4 py-3 border-b border-[#202E4C] bg-[#1B2640]/40">
        <h2 className="section-title">Tip performance</h2>
        <p className="text-xs text-slate-400 mt-0.5">A hypothetical ${t.stake} win bet on every Top Pick, Danger and Roughie, at the price recorded when the tip was published.</p>
      </header>
      {t.overall.bets === 0 && !t.refunded.length ? (
        <p className="px-4 py-6 text-sm text-slate-400" data-testid="tip-performance-empty">No settled tips yet.{t.overall.pending ? ` ${t.overall.pending} tip${t.overall.pending > 1 ? "s" : ""} awaiting results.` : " Tagged tips appear here once their races are run."}</p>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-3 p-4">
            <Summary s={t.overall} title="All tips" testid="tip-summary-overall" big />
            {CATS.map(([k, l]) => <div key={k} className="col-span-2 sm:col-span-1 last:col-span-2"><Summary s={t.categories[k]} title={l} testid={`tip-summary-${k.replace(" ", "-")}`} /></div>)}
          </div>
          {t.refunded.length > 0 && <p className="px-4 pb-3 text-[11px] text-slate-500" data-testid="tip-refunded-count">{t.refunded.length} scratched or void tip{t.refunded.length > 1 ? "s" : ""} refunded (not in profit/loss).</p>}
        </>
      )}
      <p className="px-4 py-2 text-[11px] text-slate-500 border-t border-[#202E4C]" data-testid="tip-performance-footnote">
        Hypothetical tracking only: ${t.stake} per selection (not per race), win bets settled on official results; dead heats pay a share. Tips with no recorded price are left out of profit/loss. Prices from PuntersEdge, Betfair or typed by our analyst. Past results don't guarantee future returns.
      </p>
    </section>
  );
};
